import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAuthenticatedUser } from 'store/authentication/selectors';
import { useDetailsBooking } from 'lib/hooks';
import { getSsoUserMemberId } from 'store/authentication/sso/selectors';
import { FLAG_LIVE_CHAT_ENABLED } from 'config/env';
import { preFillLiveChat, LIVE_CHAT_ANCHOR_ID } from 'lib/liveChat';
import { Global, css } from '@emotion/core';

const LiveChat = () => {
  const isAuthenticated = useSelector(isAuthenticatedUser);
  const { booking } = useDetailsBooking();
  const accountId = useSelector(getSsoUserMemberId);

  useEffect(() => {
    if (FLAG_LIVE_CHAT_ENABLED && isAuthenticated && booking) {
      preFillLiveChat({
        name: `${booking.reservation.leadGuest.name.given} ${booking.reservation.leadGuest.name.family}`,
        emailAddress: booking.travelArranger.email,
        phoneNumber: booking.travelArranger.phone,
        bookingReference: booking.reference,
        accountId,
      });
    }
  }, [isAuthenticated, booking, accountId]);

  return (
    <Global
      styles={css`
        #${LIVE_CHAT_ANCHOR_ID} .embeddedServiceHelpButton .helpButton .uiButton {
          ${isAuthenticated &&
            !!booking &&
            css`
              transform: translate(0, 0%);
            `}
        }
      `}
    />
  );
};

LiveChat.displayName = 'LiveChat';

export default LiveChat;
